"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommentsMentionAnalytics = void 0;
var _consts = require("@adsk/acc-mention/es/consts");
const getCommentsMentionAnalytics = _ref => {
  var _comment$match;
  let {
    comment,
    users,
    rolesList,
    companiesList
  } = _ref;
  const mentionRegex = /@{(.*?)}/;
  const mentions = (_comment$match = comment.match(new RegExp(mentionRegex, "g"))
  // remove the @ at the start
  ) === null || _comment$match === void 0 ? void 0 : _comment$match.map(mention => mention.substring(1)).map(mentionJsonString => {
    try {
      return JSON.parse(mentionJsonString);
    } catch {
      return null;
    }
  }).filter(mention => !!mention);
  if (!mentions || mentions.length === 0) {
    return {
      numberOfMentions: 0,
      numOfUsers: 0,
      numOfRoles: 0,
      numOfCompanies: 0,
      numOfAggregatedMentionees: 0
    };
  }
  const initialMentioneesData = {
    numberOfMentions: 0,
    numOfUsers: 0,
    numOfRoles: 0,
    numOfCompanies: 0,
    aggregatedMentioneeIds: []
  };
  const numOfMentioneesAggregator = mentions ? mentions.reduce((acc, mention) => {
    switch (mention.type) {
      case _consts.MENTION_TYPES.USER:
        return {
          ...acc,
          numOfUsers: acc.numOfUsers + 1,
          aggregatedMentioneeIds: [...acc.aggregatedMentioneeIds, mention.id]
        };
      case _consts.MENTION_TYPES.ROLE:
        const role = rolesList.find(role => role.memberGroupId === mention.id);
        const allUsersInRole = role ? users.filter(user => user.roleIds.includes(role.id)) : [];
        return {
          ...acc,
          numOfRoles: acc.numOfRoles + 1,
          aggregatedMentioneeIds: [...acc.aggregatedMentioneeIds, ...allUsersInRole.map(user => user.autodeskId)]
        };
      case _consts.MENTION_TYPES.COMPANY:
        const company = companiesList.find(company => company.memberGroupId === mention.id);
        const allUsersInCompany = company ? users.filter(user => user.companyId === company.id) : [];
        return {
          ...acc,
          numOfCompanies: acc.numOfCompanies + 1,
          aggregatedMentioneeIds: [...acc.aggregatedMentioneeIds, ...allUsersInCompany.map(user => user.autodeskId)]
        };
      default:
        return acc;
    }
  }, initialMentioneesData) : initialMentioneesData;
  return {
    numberOfMentions: mentions.length,
    numOfUsers: numOfMentioneesAggregator.numOfUsers,
    numOfRoles: numOfMentioneesAggregator.numOfRoles,
    numOfCompanies: numOfMentioneesAggregator.numOfCompanies,
    numOfAggregatedMentionees: new Set(numOfMentioneesAggregator.aggregatedMentioneeIds).size
  };
};
exports.getCommentsMentionAnalytics = getCommentsMentionAnalytics;
//# sourceMappingURL=getCommentsMentionAnalytics.js.map